<template>
  <div id="24_main">
    <v-row>
      <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
      <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6">
        <v-select
          v-model="zvitSelect"
          :items="zvits"
          dense
          solo
        ></v-select>
      </v-col>
    </v-row>

    <div v-if=" zvitSelect === 'vtps' ">
      <vtps></vtps>
    </div>
    <div v-if=" zvitSelect === 'ztgs' ">
      <ztgs></ztgs>
    </div>
 

  </div>
</template>

<script>
  import vtps from './24_vtps'
  import ztgs from './24_ztgs'
  export default {
    components: {
      vtps,
      ztgs,
    },
    data: function () {
      return {
        errorMessage: '',
        errorAlertShow: false,
        progresLineShow: false,
        zvits: [
          {text: 'Відомість товарів (склад)', value: 'vtps'},
          {text: 'Залишки товарів (група, склад)', value: 'ztgs'},
        ],
        zvitSelect: 'vtps',
        PDate: '',
        PMenuPicker: false,
        KDate: '',
        KMenuPicker: false,
        
      }
    },
    watch: {
      
    },
    methods: { 
      chPDate () {
        this.PMenuPicker = false
        //this.getMainTableData()
      },
      chKDate () {
        this.KMenuPicker = false
        //this.getMainTableData()
      },

    },
    computed: {
      
    },
    created: function () {

    },
  }
</script>